/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const LS_deleteUser = /* GraphQL */ `
  mutation LS_deleteUser($username: ID!, $reason: String, $message: String) {
    LS_deleteUser(username: $username, reason: $reason, message: $message)
  }
`;
export const LS_disableUser = /* GraphQL */ `
  mutation LS_disableUser($username: ID!, $reason: String, $message: String) {
    LS_disableUser(username: $username, reason: $reason, message: $message)
  }
`;
export const LS_syncUser = /* GraphQL */ `
  mutation LS_syncUser($username: ID!) {
    LS_syncUser(username: $username)
  }
`;
export const createOAuthCode = /* GraphQL */ `
  mutation CreateOAuthCode(
    $input: CreateOAuthCodeInput!
    $condition: ModelOAuthCodeConditionInput
  ) {
    createOAuthCode(input: $input, condition: $condition) {
      code
      sub
      clientId
      redirectUri
      scope
      codeChallenge
      codeChallengeMethod
      exp
      ttl
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const updateOAuthCode = /* GraphQL */ `
  mutation UpdateOAuthCode(
    $input: UpdateOAuthCodeInput!
    $condition: ModelOAuthCodeConditionInput
  ) {
    updateOAuthCode(input: $input, condition: $condition) {
      code
      sub
      clientId
      redirectUri
      scope
      codeChallenge
      codeChallengeMethod
      exp
      ttl
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const deleteOAuthCode = /* GraphQL */ `
  mutation DeleteOAuthCode(
    $input: DeleteOAuthCodeInput!
    $condition: ModelOAuthCodeConditionInput
  ) {
    deleteOAuthCode(input: $input, condition: $condition) {
      code
      sub
      clientId
      redirectUri
      scope
      codeChallenge
      codeChallengeMethod
      exp
      ttl
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const createPhoneAuthCode = /* GraphQL */ `
  mutation CreatePhoneAuthCode(
    $input: CreatePhoneAuthCodeInput!
    $condition: ModelPhoneAuthCodeConditionInput
  ) {
    createPhoneAuthCode(input: $input, condition: $condition) {
      code
      phone
      countryCode
      name
      gender
      birth
      exp
      ttl
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const updatePhoneAuthCode = /* GraphQL */ `
  mutation UpdatePhoneAuthCode(
    $input: UpdatePhoneAuthCodeInput!
    $condition: ModelPhoneAuthCodeConditionInput
  ) {
    updatePhoneAuthCode(input: $input, condition: $condition) {
      code
      phone
      countryCode
      name
      gender
      birth
      exp
      ttl
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const deletePhoneAuthCode = /* GraphQL */ `
  mutation DeletePhoneAuthCode(
    $input: DeletePhoneAuthCodeInput!
    $condition: ModelPhoneAuthCodeConditionInput
  ) {
    deletePhoneAuthCode(input: $input, condition: $condition) {
      code
      phone
      countryCode
      name
      gender
      birth
      exp
      ttl
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const createMemberWithdrawalHistory = /* GraphQL */ `
  mutation CreateMemberWithdrawalHistory(
    $input: CreateMemberWithdrawalHistoryInput!
    $condition: ModelMemberWithdrawalHistoryConditionInput
  ) {
    createMemberWithdrawalHistory(input: $input, condition: $condition) {
      sub
      providerUserId
      email
      reason
      message
      deletedAt
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const updateMemberWithdrawalHistory = /* GraphQL */ `
  mutation UpdateMemberWithdrawalHistory(
    $input: UpdateMemberWithdrawalHistoryInput!
    $condition: ModelMemberWithdrawalHistoryConditionInput
  ) {
    updateMemberWithdrawalHistory(input: $input, condition: $condition) {
      sub
      providerUserId
      email
      reason
      message
      deletedAt
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const deleteMemberWithdrawalHistory = /* GraphQL */ `
  mutation DeleteMemberWithdrawalHistory(
    $input: DeleteMemberWithdrawalHistoryInput!
    $condition: ModelMemberWithdrawalHistoryConditionInput
  ) {
    deleteMemberWithdrawalHistory(input: $input, condition: $condition) {
      sub
      providerUserId
      email
      reason
      message
      deletedAt
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const createSocialIdentityProvider = /* GraphQL */ `
  mutation CreateSocialIdentityProvider(
    $input: CreateSocialIdentityProviderInput!
    $condition: ModelSocialIdentityProviderConditionInput
  ) {
    createSocialIdentityProvider(input: $input, condition: $condition) {
      id
      type
      username
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const updateSocialIdentityProvider = /* GraphQL */ `
  mutation UpdateSocialIdentityProvider(
    $input: UpdateSocialIdentityProviderInput!
    $condition: ModelSocialIdentityProviderConditionInput
  ) {
    updateSocialIdentityProvider(input: $input, condition: $condition) {
      id
      type
      username
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const deleteSocialIdentityProvider = /* GraphQL */ `
  mutation DeleteSocialIdentityProvider(
    $input: DeleteSocialIdentityProviderInput!
    $condition: ModelSocialIdentityProviderConditionInput
  ) {
    deleteSocialIdentityProvider(input: $input, condition: $condition) {
      id
      type
      username
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const LS_updatePhoneNumber = /* GraphQL */ `
  mutation LS_updatePhoneNumber($username: ID!, $phone: String!) {
    LS_updatePhoneNumber(username: $username, phone: $phone)
  }
`;
export const LS_updatePassword = /* GraphQL */ `
  mutation LS_updatePassword($username: ID!, $password: String!) {
    LS_updatePassword(username: $username, password: $password)
  }
`;
export const LS_sendPhoneAuthCode = /* GraphQL */ `
  mutation LS_sendPhoneAuthCode($phone: String!, $countryCode: String) {
    LS_sendPhoneAuthCode(phone: $phone, countryCode: $countryCode)
  }
`;
export const LS_confirmPhoneAuthCode = /* GraphQL */ `
  mutation LS_confirmPhoneAuthCode(
    $code: String!
    $phone: String!
    $countryCode: String
  ) {
    LS_confirmPhoneAuthCode(
      code: $code
      phone: $phone
      countryCode: $countryCode
    )
  }
`;
export const LS_createUser = /* GraphQL */ `
  mutation LS_createUser(
    $email: String!
    $name: String
    $phone: String
    $birthdate: AWSDate
    $gender: String
    $provider: SocialIdentityProviderType
    $providerUserId: ID
    $marketing: Boolean
  ) {
    LS_createUser(
      email: $email
      name: $name
      phone: $phone
      birthdate: $birthdate
      gender: $gender
      provider: $provider
      providerUserId: $providerUserId
      marketing: $marketing
    )
  }
`;
